import {
    access,
    rich,
    recognition,
    turn,
    timbre,
    language,
    natural,
    quality,
    scene,
    model,
    prefabrication,
    standardization,
    privatization,
    cloudServices,
    installationPackage
} from "../assets/Describe"

const imgStyle = {
    width: '100%',
    height: '100%'
}
export const CustomizationBottomDescribeData = [
    {
        icon: <img style={imgStyle} src={cloudServices} alt="" />,
        title: '云服务交付',
        describe: '依托摩尔线程算力集群，提供高稳定性、高并发的语音合成服务。'
    },
    {
        icon: <img style={imgStyle} src={privatization} alt="" />,
        title: '私有化交付',
        describe: '将语音合成服务部署在搭载 Moore Threads GPU 的一体机及服务器上，进行现场私有化交付。'
    },
    {
        icon: <img style={imgStyle} src={installationPackage} alt="" />,
        title: '安装包交付',
        describe: '支持交付 TTS 服务安装包，在客户环境一键式安装。'
    }
]

export const CustomizationTopDescribeData = [
    {
        icon: <img style={imgStyle} src={model} alt="" />,
        title: '先进的模型和技术',
        describe: '模型可合成高品质音频，支持低延迟流式合成，支持音素级别时间戳输出和灵活的音频细节控制。'
    },
    {
        icon: <img style={imgStyle} src={standardization} alt="" />,
        title: '标准化的音色产出流程',
        describe: '从发音人选择、录音、数据标注，到模型训练及接入，全程提供端到端且标准化的服务。'
    },
    {
        icon: <img style={imgStyle} src={prefabrication} alt="" />,
        title: '预置多种可选音色',
        describe: '预置了标准男、标准女、儿童等多种音色可供选择。'
    }

]

export const ASRDescribeData = [
    {
        icon: <img style={imgStyle} src={recognition} alt="" />,
        title: '精准识别，边说边转',
        describe: '流式语音识别支持将用户输入的音频流实时转换成文字，准确率和实时性业内领先。'
    },
    {
        icon: <img style={imgStyle} src={rich} alt="" />,
        title: '场景丰富，使用无忧',
        describe: '录音文件识别支持将用户输入的长音频转写成文字，适用于会议转录、视频字幕等场景。'
    },
    {
        icon: <img style={imgStyle} src={access} alt="" />,
        title: '简单接入，轻松调优',
        describe: '支持公有云和私有化接入，支持语音识别定制和快速调优识别效果。'
    }
]

export const SoundConversionDescribeData = [
    {
        icon: <img style={imgStyle} src={timbre} alt="" />,
        title: '丰富音色，即刻转换',
        describe: '提供符合不同性格、不同年龄段人物形象的精品热门转换音色，适配多场景。'
    },
    {
        icon: <img style={imgStyle} src={turn} alt="" />,
        title: '边说边转，超低延时',
        describe: '可将用户输入的音频流实时转换为指定的音色，实现“边说边转”，并保持恒定的延迟，可应用直播等实时场景。'
    },
    {
        icon: <img style={imgStyle} src={language} alt="" />,
        title: '多门语言，多种情感',
        describe: '可实现跨语言、跨方言的语音转换功能，并在转换后的音频中保留原说话人的韵律、情感等元素。'
    }
]

export const SoundSynthesisDescribeData = [
    {
        icon: <img style={imgStyle} src={quality} alt="" />,
        title: '高品质，低延迟',
        describe: '先进的模型和技术，支持合成高品质音频、低延迟流式合成、音素级别时间戳输出和灵活的音频细节控制。'
    },
    {
        icon: <img style={imgStyle} src={natural} alt="" />,
        title: '高自然度，高拟真度',
        describe: '音色具有高自然度和高拟真度，能够稳定的合成高质量音频。'
    },
    {
        icon: <img style={imgStyle} src={scene} alt="" />,
        title: '多样化，多场景',
        describe: '预置了标准男、标准女、儿童等多种音色可供选择和多场景使用，提供标准化的语音合成服务。'
    }

]

export const SoundCopyDescribeData = [
    {
        icon: <img style={imgStyle} src={quality} alt="" />,
        title: '少数数据量快速复刻',
        describe: '仅需30秒至一分钟音频样本，即可实时完成音色复刻。'
    },
    {
        icon: <img style={imgStyle} src={natural} alt="" />,
        title: '高自然度和拟真度',
        describe: '音色具有高自然度和高拟真度，能够稳定的合成高质量音频。'
    },
    {
        icon: <img style={imgStyle} src={scene} alt="" />,
        title: '具有跨语言复刻能力',
        describe: '仅需采集中文或英文单语言音频样本，便可同时支持中英双语音色复刻。'
    }

]
